//#region src/themes/config.ts
/** The product's name when neither the tenant nor the pack names it. */
var DEFAULT_PRODUCT_NAME = "Payments Console";
/**
* Picks the configured brand pack from the ones the app ships. Throws, with the known
* ids, when the id is missing or unknown: a misconfigured deployment should fail at
* start-up, not quietly render another brand. `packs` can hold manifests or loaders.
*/
function selectBrandPack(id, packs) {
	const known = Object.keys(packs).sort().join(", ");
	if (!id) throw new Error(`No brand pack is configured. Set BRAND_PACK to one of: ${known}.`);
	if (!Object.hasOwn(packs, id)) throw new Error(`Unknown brand pack "${id}". Set BRAND_PACK to one of: ${known}.`);
	return packs[id];
}
/** Resolves a tenant's values over a pack's defaults. */
function resolveBrandConfig(pack, tenant = {}) {
	const brandName = tenant.brandName ?? pack.brandName ?? pack.displayName;
	const logo = tenant.logo ?? pack.logo;
	const secureHost = tenant.secureHost ?? void 0;
	return {
		pack,
		brandName,
		productName: tenant.productName ?? pack.productName ?? "Payments Console",
		...logo ? { logo: typeof logo === "string" ? logo : {
			alt: brandName,
			...logo
		} } : {},
		letterMark: !pack.logo,
		accent: tenant.accent ?? null,
		density: tenant.density ?? pack.density,
		...secureHost ? { secureHost } : {},
		helpLinks: tenant.helpLinks ?? {}
	};
}
/**
* The deployment's brand: selectBrandPack() then resolveBrandConfig(). Throws for an
* unknown or missing id.
*/
function loadBrandConfig({ brandPack, packs, tenant }) {
	return resolveBrandConfig(selectBrandPack(brandPack, packs), tenant);
}
/**
* An inline script for the HTML shell's <head>, for `mode="system"`: it sets
* <html data-theme> from the OS preference before first paint, so there is no flash of
* the wrong mode. ThemeRoot then keeps it current. Only for packs with a dark mode.
*/
var systemModeScript = "document.documentElement.setAttribute('data-theme',matchMedia('(prefers-color-scheme: dark)').matches?'dark':'light')";
//#endregion
export { DEFAULT_PRODUCT_NAME, loadBrandConfig, resolveBrandConfig, selectBrandPack, systemModeScript };

//# sourceMappingURL=config.js.map